<section class="admin-shell-section">
  <header class="admin-shell-section__header">
    <h2 class="admin-shell-section__title">
      {{ title() }}
    </h2>

    @if (description()) {
      <p class="admin-shell-section__text">
        {{ description() }}
      </p>
    }
  </header>

  <div class="admin-shell-section__body">
    <ng-content></ng-content>
  </div>
</section>